import React from "react";

import {
  RideBottomSheet,
  RideActionableCardSelector,
  RideRadioButton,
} from "@rimac-seguros/ride-system-components";

import "./styles.scss";
import helpers from "@/utils/helpers";

export const CustomListBottomSheet = ({
  list = [],
  isOpen,
  setIsOpen,
  name,
  setValue,
  value,
  title,
}) => {
  const isVE = helpers.validateVidaEndosable();

  const handleSelect = (e) => {
    setValue(name, e.target?.value);
    setIsOpen(false);
  };

  return (
    <RideBottomSheet
      isOpen={isOpen}
      onOpenChange={setIsOpen}
      className="z-max"
      title={title}
      id="bottom-sheet"
    >
      <div className="custom-list-bottom-sheet">
        {list.map((option) => {
          const isChecked = value === String(option?.value);
          return (
            <RideActionableCardSelector
              key={option?.value}
              style={{
                backgroundColor: isChecked
                  ? "var(--ride-sys-color-surface-moderate)"
                  : "",
              }}
              className="custom-list-bottom-sheet_card"
              onChange={handleSelect}
              control={
                <RideRadioButton
                  title={option?.label}
                  name={name}
                  defaultChecked={isChecked}
                  value={option?.value}
                />
              }
            >
              <div
                className={`custom-list-bottom-sheet_card-label ${
                  isVE && isChecked ? "is-checked" : ""
                }`}
              >
                <p>{option.label}</p>
              </div>
            </RideActionableCardSelector>
          );
        })}
      </div>
    </RideBottomSheet>
  );
};
